<template>
    <div class="backend-links">
        <a href="/dealshare">Deal Share</a>
        <a href="/deal-search">Deal Search</a>
        <a href="/aitrain">AI Train</a>
        <a href="/analysis">Analysis</a>
        <a href="/analytics">Analytics</a>
        <a href="/whatsapp-automation">WhatsApp Automation</a>
        <a href="/logs">Logs</a>
        <a href="/posts-deals">Posts &amp; Deals</a>
        <a href="/deal-grade-tuner">Grade Tuner</a>
        <a href="/audience-tuner">Audience Tuner</a>
        <a href="/audience-pair-tuner">Pair Tuner</a>
        <a href="/deals-pairs">Deals (Pairs)</a>
        <a href="/watched-channels">Watched Channels</a>
        <a href="/logout">LOG OUT</a>
    </div>
</template>
